import { z } from 'zod'
import { oauthScopeSchema } from '../constants/oauth-scopes.js'

/** The connect screen's answer. Deny is `approve: false` with any scope list. */
export const oauthConsentDecisionInputSchema = z.object({
  approve: z.boolean(),
  scopes: z.array(oauthScopeSchema),
})

export type OauthConsentDecisionInput = z.infer<
  typeof oauthConsentDecisionInputSchema
>
